namespace $.$$ {
	
	$mol_style_define( $hyoo_dnd_item_manage, {
		
		Menu: {
			flex: {
				basis: '35rem',
			},
		},
		
	} )
	
}
